import React, { useCallback, useEffect, useState } from "react";
import Styles from "./ViewUsers.module.css";
import { Modal, Switch, styled } from "@mui/material";
import { Close, Delete } from "@mui/icons-material";
import {
  getAllEntityUserList,
  getAllEntityUserListNew,
  getCompanyUsers,
} from "../../../../Services/CompanyAdmin/GetApiAdmin";
import { useDispatch, useSelector } from "react-redux";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { ErrorMessage } from "../../../../commons/Toast/ErrorMessage";
import {
  assignToEntity,
  unassignToEntity,
} from "../../../../Services/CompanyAdmin/AllApiAdmin";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "var(--primary-color-text)",
        ...theme.applyStyles("dark", {
          backgroundColor: "var(--primary-color-text)",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(149, 148, 148, 0.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

const ViewUsers = ({
  open,
  handleClose,
  handleEditUser,
  handleAlterUser,
  assign = false,
}) => {
  const activeRole = assign?.role?.toLowerCase();
  const entityId = assign?.id;
  const [userData, setUserData] = useState([]);
  const company_admin_id = useSelector(
    (state) => state?.persistedReducer?.user?.user?.userId,
  );
  const userDataFromStore = useSelector((state) => state?.persistedReducer);
  const companyId = userDataFromStore?.company?.companyId;

  const dispatch = useDispatch();

  const fetuserList = useCallback(async () => {
    let res = await getAllEntityUserListNew({ role: activeRole, id: entityId });
    if (res?.data?.code === 200) {
      const userIds = res?.data?.data;
      setUserData(userIds);
    } else {
      ErrorMessage(res?.data?.error || res?.data?.message);
    }
  }, [activeRole, entityId]);

  useEffect(() => {
    if (entityId && activeRole) {
      fetuserList();
    }
  }, [activeRole, dispatch, entityId, fetuserList]);

  const handleAssignEntity = async ({ data }) => {
    if (!data?.isChecked) {
      let res = await assignToEntity(data);
      if (res?.data?.code === 200) {
        fetuserList();
      }
    } else {
      let res = await unassignToEntity(data);
      if (res?.data?.code === 200) {
        fetuserList();
      }
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className={`popupModal ${Styles.createEditModalCont}`}>
        <div className={`display_flex_row modalHeading ${Styles.modalHeading}`}>
          <div className={`headingText ${Styles.headingSec}`}>
            List of Users
          </div>
          <Close
            style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>
        <div className={Styles.listContainers}>
          <div className="display_flex_row tableHeading">
            <div style={{ width: "20%" }}>Name</div>
            <div style={{ width: "20%" }}>Username</div>
            <div style={{ width: "20%" }}>Email</div>
            <div style={{ width: "10%" }}>Phone</div>
            <div style={{ width: "5%" }}>Edit</div>
            <div style={{ width: "5%" }}>Hold</div>
            {assign?.status && <div style={{ width: "5%" }}>Assign</div>}
            {/* {assign?.status && <div style={{ width: "5%" }}>Access</div>} */}
          </div>
          <div className={`scroll_bar_y ${Styles.detailsLists}`}>
            {userData?.map((ele) => (
              <div className="display_flex_row tableDetails">
                <div style={{ width: "20%" }}>{ele?.fullName}</div>
                <div style={{ width: "20%" }}>{ele?.userName}</div>
                <div
                  style={{
                    width: "20%",
                    textWrap: "wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {ele?.email}
                </div>
                <div style={{ width: "10%" }}>{ele?.phone}</div>
                <div
                  style={{
                    width: "5%",
                  }}
                >
                  {company_admin_id === ele?.userId || ele?.isTrader ? (
                    <>-</>
                  ) : (
                    <BorderColorIcon
                      style={{
                        fontSize: "20px",
                        color: "var(--primary-color-text)",
                        cursor: "pointer",
                      }}
                      onClick={() => handleEditUser(ele)}
                    />
                  )}
                </div>
                <div
                  style={{
                    width: "5%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {company_admin_id === ele?.userId || ele?.isTrader ? (
                    <>-</>
                  ) : (
                    <AntSwitch
                      checked={ele?.verified}
                      onChange={() =>
                        handleAlterUser({
                          data: ele,
                          type: ele?.verified ? "UN_VERIFIED" : "VERIFIED",
                        })
                      }
                    />
                  )}
                </div>
                {assign?.status && (
                  <>
                    <div
                      style={{
                        width: "5%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {company_admin_id === ele?.userId || ele?.isTrader ? (
                        <>-</>
                      ) : (
                        <AntSwitch
                          checked={ele?.isAssigned}
                          onChange={() =>
                            handleAssignEntity({
                              data: {
                                isChecked: ele?.isAssigned,
                                entityType:
                                  activeRole === "consumer"
                                    ? "CONSUMER"
                                    : "GENERATOR",
                                entityId: entityId,
                                companyId: companyId,
                                userIds: [ele?.userId],
                              },
                            })
                          }
                        />
                      )}
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewUsers;
